import api from 'api'

export type ExternalTrainingStatus =
  | 'pending_provisioning'
  | 'provisioned'
  | 'provisioning_failed'
  | 'provisioning_no_course'
  | 'completed'
  | 'revoked'

export type ExternalTraining = {
  trainingType: string
  status: ExternalTrainingStatus
  externalLearnerId: string | null
  provider: string
  nextDueAt: string | null
}

export const getExternalTraining = async (
  userId: number
): Promise<ExternalTraining[]> => {
  const result = await api.get(`/admin/external_training/${userId}`)
  return result.data as ExternalTraining[]
}
